import PropTypes from 'prop-types';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withBuyTogether } from '../../../utils/BuyTogetherContext';
import getImages from '../../../utils/GetImages';
import { withLabels } from '../../../utils/LabelsContext';
import _ from '../../../utils/LodashImports';
import { noop } from '../../../utils/noop';
import { withProduct } from '../../../utils/ProductContext';
import { getVariant } from '../../../utils/variant';
import BodyCopy from '../../ui/BodyCopy/BodyCopy';
import Button from '../../ui/Button/Button';
import LinkButton from '../../ui/LinkButton/LinkButton';
import { renderBundleItem, renderCollections, showWarningMessage } from '../Cart.Utils';
import CartItem from '../CartItem/CartItem';
import { CartAddedBundleStyles, CartBrandNameStyle, CartDescriptionStyle, CartMobileStyles } from './CartMobile.style';

const CartMobile = ({ cart, setBusy, labels, product, appCtx, buytogether, hasCrossSelling, setCrossSelling }) => {
  const { bundles, attributes, disableQuantitySelection } = product;
  const { viewTemplate } = attributes;
  const { regionCode } = appCtx;

  const {
    cartItems,
    bundleItems,
    textDictionary,
    addProduct,
    removeProduct,
    setWarrantyOption,
    bundledProductOrigin,
    typeACollections = [],
    addCollection,
    endPoints,
    removeCollection,
    setWarrantyOptionCurrent,
    isAtgPrice = true,
    limitAlerts,
  } = cart;

  if (!cartItems) {
    return null;
  }

  const { A2C_CONTINUE_SHOPPING = '', A2C_VIEW_BASKET_MKP = 'Ir al Carro' } = _.get(
    appCtx,
    'siteConfig.textDictionary',
    {}
  );

  const { variants, currentVariant, id: productId, brandName, stockUnits } = product;

  const guideSymbol = _.get(product, 'guideSymbol', false);
  const isSoftlineProduct = product.layoutType === constants.PRODUCT_CONSTANTS.SOFTLINE;
  const currentVariantData = getVariant(variants, currentVariant);
  const { colorCode, size = '', colorName = '' } = _.get(currentVariantData, 'attributes', {});

  const getVariantDetails = () => {
    if (colorName && size) {
      return `${colorName},${size}`;
    }
    return `${colorName} ${size}`;
  };

  const variantDetails = isSoftlineProduct || guideSymbol ? getVariantDetails() : '';

  const isCFMediasEnabled = _.get(appCtx, 'siteConfig.toggles.isCFMediasEnabled', false);
  const mediaDomains = _.get(appCtx, 'siteConfig.configurations.mediaDomains', []);
  const fallBackImagesDomain = _.get(appCtx, 'siteConfig.textDictionary.FALLBACK_IMAGES_DOMAIN', '');
  const sellerName = _.get(product, 'variants[0].offerings[0].sellerName', '').toLowerCase();
  const imageBaseURL = getImages({
    variantId: currentVariant,
    regionCode,
    isCFMediasEnabled,
    sellerName,
    url: _.get(currentVariantData, 'medias[0].url', ''),
    mediaDomains,
    fallBackImagesDomain,
  });

  const renderBrandName = (brand) => (
    <BodyCopy size="copy4" type="secondary" isHighlighted>
      <span className="brand-name">{`${brand}`.toUpperCase()}</span>
      <style jsx>{CartBrandNameStyle}</style>
    </BodyCopy>
  );

  const renderDescription = (displayName) => (
    <BodyCopy size="copy14">
      <span className="description">{displayName}</span>
      <style jsx>{CartDescriptionStyle}</style>
    </BodyCopy>
  );

  const isTypeA = viewTemplate === constants.VIEW_TEMPLATE.TYPE_A;
  const isBundlesAvailable = bundles && bundles.length !== 0;

  const closeModal = () => {
    setBusy(false);
    cart.setShowCart(false);
    if (buytogether?.data?.length) {
      buytogether.resetData();
    }
  };

  const hasWarranties = cartItems.filter((item) => item.warrantyOptions);
  const hasServices = cartItems.filter((item) => item.assemblyOptions);

  let bodyClass = hasWarranties.length > 0 || product.warrantyOptions ? 'body-medium' : '';
  bodyClass = hasWarranties.length > 0 && hasServices.length > 0 ? 'body-large' : bodyClass;

  return (
    <div className="cart-mobile">
      <div className="header mkp">
        <i className="csicon-icon-success-circle">
          <span className="sr-only">{labels.ITEM_ADDED_A11Y_LABEL}</span>
        </i>
        <span className="label">{labels.ITEM_ADDED_IN_CART}</span>
      </div>

      <div
        className={`body ${!hasCrossSelling && 'small'} ${
          showWarningMessage(stockUnits, cart) && 'with-warning'
        } ${bodyClass}`}
      >
        <div className="cart-items">
          {cartItems &&
            cartItems.map((item) => (
              <CartItem
                key={item.skuId}
                setBusy={setBusy}
                item={item}
                textDictionary={textDictionary}
                onRemoveFromCart={removeProduct}
                setWarrantyOption={setWarrantyOption}
                onAddToCart={addProduct}
                showButton={false}
                setCrossSelling={setCrossSelling}
                variantDetails={variantDetails}
                disableQuantitySelection={disableQuantitySelection}
                setWarrantyOptionCurrent={setWarrantyOptionCurrent}
                isAtgPrice={isAtgPrice}
                limitAlerts={limitAlerts}
              />
            ))}
        </div>

        {isBundlesAvailable && (
          <div className="bundles">
            {renderBundleItem({
              bundledProductOrigin,
              bundles,
              product,
              labels,
              imageBaseURL,
              CartAddedBundleStyles,
              bundleItems,
              setBusy,
              textDictionary,
              removeProduct,
              setWarrantyOption,
              setWarrantyOptionCurrent,
              addProduct,
              renderDescription,
              renderBrandName,
              isTypeA,
              limitAlerts,
            })}
          </div>
        )}

        {isTypeA && (
          <div className="collections">
            {renderCollections({
              labels,
              variants,
              colorCode,
              size,
              brandName,
              imageBaseURL,
              productId,
              setBusy,
              textDictionary,
              isBundlesAvailable,
              removeProduct: async (props) => removeCollection({ ...props }),
              addProduct: async (props) => addCollection({ ...props }),
              cartItems,
              collection: typeACollections,
              isAtgPrice,
              limitAlerts,
            })}
          </div>
        )}
      </div>

      <div className="footer mkp">
        {showWarningMessage(stockUnits, cart) && (
          <div className="warning">
            <i className="csicon-alert">
              <span className="sr-only">{labels.WARNING_A11Y_LABEL}</span>
            </i>
            <span>{labels.LOW_STOCK_WARNING}</span>
          </div>
        )}
        <div className="sub-footer">
          <div className="addToCart-btn">
            <LinkButton href={_.get(endPoints, 'baskePagetUri.path', '/')} type="mkp-secondary">
              {A2C_VIEW_BASKET_MKP}
            </LinkButton>
          </div>
          <Button type="tertiary-link" onClick={closeModal}>
            {A2C_CONTINUE_SHOPPING}
          </Button>
        </div>
      </div>
      <style jsx>{CartMobileStyles}</style>
    </div>
  );
};

CartMobile.defaultProps = {
  setBusy: noop,
  buytogether: {},
  hasCrossSelling: false,
  setCrossSelling: noop,
};

CartMobile.propTypes = {
  cart: PropTypes.object.isRequired,
  setBusy: PropTypes.func,
  labels: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  buytogether: PropTypes.object,
  hasCrossSelling: PropTypes.bool,
  setCrossSelling: PropTypes.func,
};

export default withApplicationContext(withLabels(withProduct(withBuyTogether(CartMobile))));
export { CartMobile };
